/**
 * Words and labels shared by every part of the app (design system, shell, features). A feature uses these
 * instead of repeating them in its own catalogue.
 */
export const fr = {
  /* Actions */
  close: 'Fermer',
  back: 'Retour',
  retry: 'Réessayer',
  cancel: 'Annuler',
  confirm: 'Confirmer',
  continue: 'Continuer',
  save: 'Enregistrer',
  edit: 'Modifier',
  remove: 'Retirer',
  see: 'Voir',
  seeMore: 'Voir plus',
  signIn: 'Se connecter',
  signUp: 'Créer un compte',
  backHome: 'Retour à l’accueil',
  /* States */
  loading: 'Chargement',
  new: 'Nouveau',
  soon: 'Bientôt',
  total: 'Total',
  /* Design system */
  'stepper.remove': 'Retirer : {label}',
  'stepper.add': 'Ajouter : {label}',
  'calendar.previous': 'Mois précédent',
  'calendar.next': 'Mois suivant',
  'calendar.unavailable': '{day}, indisponible',
  'stars.label': 'Note',
  'stars.value': '{label} : {value} sur 5',
  'stars.option': '{value} sur 5',
  /* Brand and universes */
  'brand.home': 'Cardnd, accueil',
  vehicles: 'Véhicules',
  experiences: 'Expériences',
  cars: 'Voitures',
  motos: 'Motos',
  favourites: 'Favoris',
  messages: 'Messages',
  profile: 'Profil',
  /** Experience categories: the «all» filter (the stored value is `ALL_CATEGORIES`). */
  allCategories: 'Toutes',
  /** The site's description, for a page that has none of its own (index.html's text, `<Seo>`). */
  'seo.siteDescription':
    "Louez une voiture, une moto ou réservez une expérience auprès d'agences vérifiées au Maroc. Prix total affiché, paiement sécurisé.",
} as const;
